import React, { useEffect, useState } from 'react';
import { ConfirmFlexModal, Label } from '@riac/design-system';
import { Checkbox } from 'src/components/Input/CheckboxInput/CheckboxInput';
import { BidDetails } from 'src/components/Bidding/BidDetails';
import { Link } from 'react-router-dom';

export const ConfirmBidModal = ({ onConfirm, onReject, item, message, amount }) => {
  const [checkItem, setCheckItem] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [itemNotice, setItemNotice] = useState('');

  const fetchItemCheck = async () => {
    const itemNoticeResults = await (await fetch('/api/timed-auction/check-item', { credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ amCode: item.A_MCode }),
    })).json();
    if(itemNoticeResults.success && itemNoticeResults.itemNoticeText) {
      setItemNotice(itemNoticeResults.itemNoticeText);
    }
  };

  useEffect(() => {
    fetchItemCheck().then();
  }, []);

  return (<ConfirmFlexModal
    title={'Place Bid?'}
    isOpen={true}
    confirmButtonText={'Place'}
    onConfirm={() => {
      if(itemNotice.length > 0 && !checkItem) {
        setErrorMessage('Must agree acknowledge the statement by clicking the checkbox');
      } else {
        onConfirm(true);
      }
    }}
    isDismissable
    rejectButtonText={'Cancel'}
    onReject={() => {
      onReject();
    }}
  >
    <div className={'text-center w-100'}>Buyers Premium: 18.5%</div>
    {itemNotice.length > 0
      && <Label className={'bg-amber-300 p-3'}>
        <Checkbox
          checked={checkItem}
          onChange={() => setCheckItem(!checkItem)}
        /> <span dangerouslySetInnerHTML={{ __html: itemNotice }}/>
      </Label>
    }
    {errorMessage && <p className={'bg-red-700 text-white p-3'}>
      {errorMessage}
    </p>}
    <p className={'text-slate-700 py-3'}>
      All bids in a RIAC on Time are <strong>FINAL and can NOT be changed.</strong>
    </p>
    <p className={'text-slate-700 py-3'}>
      {message}
    </p>
    <BidDetails item={item}/>
    <p className={'text-slate-700 py-3'}>Please see our <Link className={'text-gold-600 hover:text-gold-700'} to={'/terms-and-conditions#5'} target={'_blank'}>terms and conditions</Link> for more information.</p>
  </ConfirmFlexModal>);
};
